'use strict';

module.exports = require('us').STATES.map(function(st) {
  return {
    abbr: st.abbr,
    name: st.name
  };
});
